import React from 'react'
import { Item, Tab, Header, Icon } from 'semantic-ui-react'
import { Container, Row, Col, ProgressBar } from 'react-bootstrap'
import Pengalaman from '../compo/Pengalaman';
import Pendidikan from '../compo/Pendidikan';

const paragraph = "keep learning..."
const panes = [
    {
        menuItem: 'Experience', render: () => <Tab.Pane attached={false}>
            <Header as='h2'>
                <Icon name='tasks' />
                <Header.Content>Experience</Header.Content>
            </Header>
            <br />
            <Pengalaman />
        </Tab.Pane>
    },
    {
        menuItem: 'Soft Skill', render: () => <Tab.Pane attached={false}>
            <Header as='h2'>
                <Icon name='code' />
                <Header.Content>Skills</Header.Content>
            </Header>
            <br />
            <Container>
                <Row >
                    <Col md={6}>
                        <Item.Group>
                            <Item>
                                <Item.Image style={{ width: '5rem' }} src='https://i.pinimg.com/564x/a2/1f/af/a21faffb83f9418b9a723829218103b5.jpg' alt="" />

                                <Item.Content>
                                    <Item.Header>HTML</Item.Header>
                                    <Item.Meta>
                                        <span className='skill'><ProgressBar variant="danger" animated now={90} label={`${90}%`} /></span>
                                    </Item.Meta>
                                    <Item.Description>{paragraph}</Item.Description>
                                </Item.Content>
                            </Item>

                            <Item>
                                <Item.Image style={{ width: '5rem' }} src='https://cdn.iconscout.com/icon/free/png-256/css-118-569410.png' alt="" />

                                <Item.Content>
                                    <Item.Header>CSS</Item.Header>
                                    <Item.Meta>
                                        <span className='skill'><ProgressBar animated now={71} label={`${71}%`} /></span>
                                    </Item.Meta>
                                    <Item.Description>{paragraph}</Item.Description>
                                </Item.Content>
                            </Item>

                            <Item>
                                <Item.Image style={{ width: '5rem' }} src='https://png.pngtree.com/svg/20170719/91de50e59c.png' alt="" />
                                <Item.Content >
                                    <Item.Header>Javascript</Item.Header>
                                    <Item.Meta>
                                        <span className='skill'><ProgressBar variant="warning" animated now={65} label={`${65}%`} /></span>
                                    </Item.Meta>
                                    <Item.Description>{paragraph}</Item.Description>
                                </Item.Content>
                            </Item>
                        </Item.Group>
                    </Col>
                    <Col>
                        <Item.Group>
                            <Item>
                                <Item.Image style={{ width: '5rem' }} src='http://pluspng.com/img-png/jquery-logo-png-jquery-320.png' alt="" />

                                <Item.Content>
                                    <Item.Header>JQuery</Item.Header>
                                    <Item.Meta>
                                        <span className='skill'><ProgressBar animated now={65} label={`${65}%`} /></span>
                                    </Item.Meta>
                                    <Item.Description>{paragraph}</Item.Description>
                                </Item.Content>
                            </Item>

                            <Item>
                                <Item.Image style={{ width: '5rem' }} src='https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png' alt="" />

                                <Item.Content>
                                    <Item.Header>ReactJs</Item.Header>
                                    <Item.Meta>
                                        <span className='skill'><ProgressBar variant="success" animated now={70} label={`${70}%`} /></span>
                                    </Item.Meta>
                                    <Item.Description>{paragraph}</Item.Description>
                                </Item.Content>
                            </Item>

                            <Item>
                                <Item.Image style={{ width: '5rem' }} src='https://cdn1.iconfinder.com/data/icons/logos-3/304/codeigniter-512.png' alt="" />

                                <Item.Content>
                                    <Item.Header>Codeigniter</Item.Header>
                                    <Item.Meta>
                                        <span className='skill'><ProgressBar variant="danger" animated now={45} label={`${45}%`} /></span>
                                    </Item.Meta>
                                    <Item.Description>{paragraph}</Item.Description>
                                </Item.Content>
                            </Item>
                        </Item.Group>
                    </Col>
                    {/* ================================================================================================== */}
                </Row>
                <hr />
                <h3>Adobe tools</h3>
                <Row md={{ span: 9, offset: 1 }}>
                    <Col md={6} xs={{ span: 6, offset: 3 }}>
                        <Item.Group>
                            <Item>
                                <Item.Image style={{ width: '5rem' }} src='https://cdn.iconscout.com/icon/free/png-256/photoshop-8-226474.png' alt="" />

                                <Item.Content>
                                    <Item.Header>Adobe Photoshop</Item.Header>
                                    <Item.Meta>
                                        <span className='skill'><ProgressBar animated now={70} label={`${70}%`} /></span>
                                    </Item.Meta>
                                    <Item.Description>{paragraph}</Item.Description>
                                </Item.Content>
                            </Item>

                            <Item>
                                <Item.Image style={{ width: '5rem' }} src='https://images.g2crowd.com/uploads/product/image/large_detail/large_detail_1489696903/adobe-illustrator.png' alt="" />

                                <Item.Content>
                                    <Item.Header>Adobe Illustrator</Item.Header>
                                    <Item.Meta>
                                        <span className='skill'><ProgressBar variant="warning" animated now={60} label={`${60}%`} /></span>
                                    </Item.Meta>
                                    <Item.Description>{paragraph}</Item.Description>
                                </Item.Content>
                            </Item>

                            <Item>
                                <Item.Image style={{ width: '5rem' }} src='https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Adobe_XD_CC_icon.svg/788px-Adobe_XD_CC_icon.svg.png' alt="" />
                                <Item.Content >
                                    <Item.Header>Adobe XD</Item.Header>
                                    <Item.Meta>
                                        <span className='skill'><ProgressBar variant="danger" animated now={75} label={`${75}%`} /></span>
                                    </Item.Meta>
                                    <Item.Description>{paragraph}</Item.Description>
                                </Item.Content>
                            </Item>
                        </Item.Group>
                    </Col>
                </Row>

            </Container>
        </Tab.Pane>
    },

    {
        menuItem: 'Education', render: () => <Tab.Pane attached={false}>
            <Header as='h2'>
                <Icon name='graduation' />
                <Header.Content>Education</Header.Content>
            </Header>
            <br />
            <Pendidikan />
        </Tab.Pane>
    },
]

const Cv = () => (

    <Container>
        <Row>
            <Col>
                < Tab menu={{ pointing: true }} panes={panes} />
            </Col>
        </Row>
    </Container>


)

export default Cv